import { Link, withRouter } from 'react-router-dom';
import { Loading } from '@salesperformanceint/e4shared';
import TaskIcon from 'views/user/task/components/taskIcon';
import { e4Format, isPast, isToday } from 'helpers/dates';

export const PathwayModal = ({ data, st }) => {
    if (!data) {
        return <Loading />;
    }

    return (
        <div>
            {data.map(d => {
                return (
                    <div key={d.id} className="flex flex-top mb10">
                        <i className="fa fa-calendar mr10 mt10 text-lg" />
                        <div className="flex-grow">
                            <div>
                                <span className="mr10">
                                    <Link to={`/develop/pathways/${d.profile_Id}?id=${d.id}`}>{d.name}</Link>
                                    <TaskIcon icons={d.icons} />
                                </span>
                            </div>
                            <div>
                                {st('Due')}: {e4Format(d.date_Due)}
                            </div>
                            <div>
                                {isPast(d.date_Due) && !isToday(d.date_Due) && (
                                    <span className="mr10">
                                        <label className="label label-danger uppercase">{st('Overdue')}</label>
                                    </span>
                                )}
                            </div>
                        </div>
                    </div>
                );
            })}
        </div>
    );
};

export default withRouter(PathwayModal);
